import React, { Component } from 'react';

import { Logo, Button } from '../util';

import '../App.css';

/**
 * @prop runAppHandler
 */
export default class Writeup extends React.Component {

  constructor (props) {
    super(props);


  }


  render() {
    return (
      <div style={{textAlign: 'left'}}>
        <header className="App-header">
          <div id="logo">
            <div onClick={this.props.openDashboardHandler}>
              <h1 style={{fontSize: '2.3em', position: 'relative', bottom: '.8em', textShadow: 'none'}}>Diary</h1>
            </div>
          </div> 
        </header>

        <article>
          <h1>About this</h1>

          <p>Welcome to CGP Diary!</p>

          <p>This small web application is very convenient to keep a diary ON THE INTERNET.
            And this stores the data on your PC only (browser's localStorage), so you can write anything that you want to write with security...
          </p>

          <p>
            Keeping a diary is VERY IMPORTANT and meaningful action.
            The memory on your brain changes by the second. The hings which your brain judges unnecessary will disappears after few seconds all too soon.
            So people have written down.
          </p>

          <h2>Local vs Online</h2>

          <p>What do you think about keeping a diary on the Internet?
            To be honest, I prefer to keep it in the real world personally.
            Let's discuss pros and cons of the two ways to keep a diary.
            I wrote the pros only because cons of one way is always pros of the other way.
          </p>

          <p>
            <b>Pros of writing the date on the Internet</b>: One of the most biggest pros is its convenience.
            Nowadays, many people wear a device can connect the Internet next their skin.
            So, they can write it at ease whenever they want to do it.
            And the imformation on the Internet never dies theoretically. As long as the data is stored on a server, you (anyone if you want) can read the diary forever.
            Furthermore, it's easy to look back over the past by reading the diary.
            Things in the real world rots anon and you may forget the places stored the stacked diaries.  
          </p>

          <p>
            <b>Pros of writing the date in the real world</b>: 
            As I wrote above, the way uses the Internet is convenient because people can write a diary whenever they wanna do.
            However, for those don't have portable devices or if you want to write a diary <b>whenever</b> in a true sense, this way is more suitable.
            And the things in the real world have unlimitted imformation.
            Shape of the letter, sort of the paper or the ink, and so on. 
            It is very fun to examine those metadatas when you read the diary and look back over the past.
          </p>

          <h2>Summary</h2>

          <p>
            Anyway, I recommend keeping a diary in either way.
            And, if you decided to store it on the Internet, you must use this application :)
          </p>
        </article>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/page/Writeup.js